"use client";
import "../chunk-GOCCUU3Z.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { CpslAvatar, CpslIcon, CpslText } from "@getpara/react-components";
import styled from "styled-components";
import { formatPhoneNumber } from "../utils/formatPhoneNumber.js";
function defaultDisplayName({ authType, identifier }) {
  switch (authType) {
    case "email":
      return identifier.toLowerCase();
    case "phone":
      return formatPhoneNumber(identifier);
    case "farcaster":
      return `@${identifier}`;
    case "telegram":
      return `Telegram User @${identifier}`;
    default:
      return null;
  }
}
const UserIdentifier = ({ identifier, authType, displayName, pfpUrl }) => {
  const shouldHideAvatar = authType === "externalWallet";
  let icon;
  switch (authType) {
    case "email":
      icon = "mail";
      break;
    case "phone":
      icon = "phone";
      break;
    case "farcaster":
      icon = "farcasterBrand";
      break;
    case "telegram":
      icon = "telegramBrand";
      break;
  }
  return /* @__PURE__ */ jsxs(Container, { children: [
    !shouldHideAvatar && /* @__PURE__ */ jsx(IconContainer, { children: pfpUrl ? /* @__PURE__ */ jsx(Avatar, { src: pfpUrl, size: "20px" }) : /* @__PURE__ */ jsx(Icon, { icon, size: authType === "telegram" ? "20px" : "13px" }) }),
    /* @__PURE__ */ jsx(IdentifierText, { variant: "bodyS", weight: "medium", children: displayName || defaultDisplayName({ authType, identifier }) })
  ] });
};
const Container = styled.div`
  padding: 8px 12px 8px 8px;
  border-radius: 1000px;
  background-color: var(--cpsl-color-background-4);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;
const IdentifierText = styled(CpslText)`
  --color-override: var(--cpsl-color-background-96);
`;
const IconContainer = styled.div`
  display: flex;
  background: var(--cpsl-color-background-0);
  align-items: center;
  justify-content: center;
  border-radius: 1000px;
  width: 20px;
  height: 20px;
`;
const Icon = styled(CpslIcon)`
  --icon-color: var(--cpsl-color-text-primary);
`;
const Avatar = styled(CpslAvatar)`
  --container-border-width: 0;
  --container-padding: 0;
`;
export {
  UserIdentifier
};
